import React, {Component} from "react";
import {Accordion, Card} from "react-bootstrap";
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp} from "@fortawesome/sharp-solid-svg-icons";

import {findLatestResultat} from "./utils";


class AA extends Component {
    constructor(props) {
        super();
        this.state = {
            activiteApprentissage: props.item
        }
    }

    static propTypes = {
        item: PropTypes.array.isRequired,
    };


    updateCollapsedStatus = (aa) => {
        const activiteApprentissage = this.state.activiteApprentissage;

        const index = activiteApprentissage.indexOf(aa);
        activiteApprentissage[index].isCollapsed = !this.state.activiteApprentissage[index].isCollapsed;

        this.setState({
            activiteApprentissage: activiteApprentissage
        });
    }

    render() {
        return (
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "12px", width: "100%"}} >
                {this.state.activiteApprentissage.map((m, key) => {
                    const latestResult = findLatestResultat(m);

                    return (
                        <Accordion style={{width:'100%'}} key={key}>
                            <Card>
                            <Accordion.Toggle className="clickable" as={Card.Header} eventKey={key.toString()} onClick={() => this.updateCollapsedStatus(m)}>
                                <span className="float-left">
                                    {m.ActiviteApprentissageCode}
                                </span>
                                <div className="float-right" style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "8px"}}>
                                <span>
                                    {m.ProgrammeEtudiantDispense ? "D" : (latestResult !== null ? (<span className="result">{latestResult + "/20"}</span>) : "")}<small>{this.props.item.ProgrammeEtudiantTransfertResultat ? " (T)" : ""}{this.props.item.ProgrammeEtudiantReportResultat ? " (R)" : ""}</small>
                                </span>

                                { m.isCollapsed
                                    ? <FontAwesomeIcon type={"p"} className={"fa-fw"} icon={faChevronDown}/>
                                    : <FontAwesomeIcon type={"p"} className={"fa-fw"} icon={faChevronUp}/>
                                }
                                </div>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={key.toString()}>
                                <>
                                    <Card.Body>
                                        <p>{m.ActiviteApprentissageLibelle}</p>
                                        {m.GroupeActiviteApprentissageCode &&
                                            <p className="text-center">{m.GroupeActiviteApprentissageCode}</p>}
                                        {m.ResultatEtudiantResultatPartiel !== null && <div className="text-right result">Partiel: {m.ResultatEtudiantResultatPartiel.toFixed(2).padStart(5, '0')}/20</div>}
                                        {m.ResultatEtudiantInscritS1 && <div className="text-right result">S1: {m.ResultatEtudiantResultatS1? m.ResultatEtudiantResultatS1.toFixed(2).padStart(5, '0') : '--.--'}/20</div>}
                                        {m.ResultatEtudiantInscritS2 && <div className="text-right result">S2: {m.ResultatEtudiantResultatS2? m.ResultatEtudiantResultatS2.toFixed(2).padStart(5, '0') : '--.--'}/20</div>}
                                        {m.ResultatEtudiantInscritS3 && <div className="text-right result">S3: <span className={"result"}>{m.ResultatEtudiantResultatS3 ? m.ResultatEtudiantResultatS3.toFixed(2).padStart(5, '0') : '--.--'}/20</span></div>}
                                    </Card.Body>
                                    <Card.Footer className="bg-white">
                                        <span className="float-left">
                                            {
                                                m.Q1 && m.Q2 ? "Q1/Q2" :
                                                    m.Q1 ? "Q1" :
                                                        m.Q2 ? "Q2" : ""
                                            }
                                        </span>
                                    </Card.Footer>
                                </>
                            </Accordion.Collapse>
                        </Card>
                        </Accordion>
                    );
                })}
            </div>
        );
    }
}

export default AA;